export default __webpack_public_path__ + "static/media/cheeky.7cf487fa.mp4";